import { action, observable } from 'mobx';
import { ImportCreateForm } from 'application/import/forms';
import { BaseEditViewStore, BaasicDropdownStore} from 'core/stores';
import {applicationContext } from 'core/utils';
import { FacilityService } from 'application/facility/services';
import { ImportService } from 'application/import/services';
import { ScheduleService } from 'application/schedule/services';
import moment from 'moment';
import { toUTCDate } from 'core/utils';
import _ from 'lodash';

@applicationContext
class ImportCreateViewStore extends BaseEditViewStore {
    @observable accessor nextDeliveryDates = [];
    @observable accessor nextDateOfServices = [];
    constructor(rootStore) {
        const service = new ImportService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'file',
            Form: ImportCreateForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        var file = this.form.fields.get("file").files[0];
                        await service.upload({file: file, facility: resource.facility, scheduledDate: resource.scheduledDate, dateOfService: resource.dateOfService});
                    }
                }
            },
            FormClass: ImportCreateForm,
        });

        this.scheduleService = scheduleService;

        this.facilityService = facilityService;

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 500, inActive: false });
                let items = _.map(response.data.item, item => {
                    return _.extend(item, {
                        name: item == null ? null : item.name
                    });
                });
                response.data.item = items;
                return response.data.item;
            },
            onChange: async (facility )=>{
                this.form.$('scheduledDate').value = null;
                this.form.$('dateOfService').value = null;
                this.form.set({ facility: facility });
                await this.getNextDays(facility)
                //this.dateStore.setItems(this.nextDeliveryDates);
                //this.dateStore.setOption('disabled', false);
            }
        });
    }

    @action.bound
    async getNextDays(facilityId) {
        let dateFrom = new Date();
        const typeResponse = await this.scheduleService.getTypes();
        var calendarType = _.find(typeResponse.item, { abrv: 'delivery' });

        let params = {
            rpp: 3,
            page: 1,
            sort: 'date|asc',
            dateFrom: moment(dateFrom).add(-6,'d').format('YYYY-MM-DD'),
            facilityId: facilityId,
            embed: 'Facility,AreaOfCare,FacilityScheduleDates,ParentFacilityScheduleDate',
            calendarTypeId: calendarType.id
        };

        var response = await this.scheduleService.find(params);

        if (response.data.item.length > 0)
        {
            let nextDeliveryDates = _.map(response.data.item, item => {
                const deliveryTask = { ...item };
                const deliveryDate = deliveryTask && deliveryTask.date;
                const dateOfService = deliveryTask && deliveryTask.parentFacilityScheduleDate && deliveryTask.parentFacilityScheduleDate.dateOfService;

                return _.extend(item, {
                    deliveryDate: deliveryDate,
                    name: `${deliveryDate && toUTCDate(deliveryDate)} (DOS: ${dateOfService ? toUTCDate(dateOfService) : ' / '}) - ${item.facility.name} ${item.areaOfCare ? '(' + item.areaOfCare.name + ')' : ''}`
                });
            });

            this.nextDeliveryDates = nextDeliveryDates;
        }
        else {
            this.nextDeliveryDates = null;
        }
    }

    @action.bound
    async updateScheduledDate(deliveryDate, dateOfService) {
        this.form.$('dateOfService').value = dateOfService;
        this.form.$('scheduledDate').value = deliveryDate;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('File uploaded successfully.'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err && err.data ? err.data : 'Error occured while trying to upload the file.');
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default ImportCreateViewStore;
